const $ = jQuery.noConflict();
/* eslint-disable */
'use strict';
const FormHelpers = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domSubmitBtn: $('.wpcf7-submi'),
	$domFormWrap: $('.cf7-holder__inner'),

	$domResumeTxt: $('.js-txt-resume'),
	$domResumeFile: $('.wpcf7-file'),

	$domSelShow: $('.js-holidays__drop-sel-show'),

	/** @description Initialize */
	init: function() {
		this.afterFormSubmit();
		this.contactScroll();
		this.appending();
		this.submitEffect();
		this.resumeDate();
	},

	/**
	 * @description CF7 after submit popup trigger. Structure-example ( https://www.dropbox.com/s/oyj5revbgwigzxr/download.jpg?dl=0 )
	 * @example Global.functions.afterFormSubmit('.js-cf7-holder', 'form-is-sent', 8000);
	 * @param {string} formHolder - form holder class (recommended/default is '.js-cf7-holder')
	 * @param {string} sentClass - class added to form parent to trigger popup (default is 'form-is-sent')
	 * @param {number} delay - delay time before sentClass is removed (default delay time is 5000ms)
	 */
	afterFormSubmit: (formHolder = '.js-cf7-holder', sentClass = 'form-is-sent', delay = 2000) => {
		document.addEventListener('wpcf7mailsent', (e) => {
			/* e.preventDefault(); */
			/* const formId = e.detail.id; */
			const formId = e.target;

			/* $(`#${formId}`).parents(formHolder).addClass(sentClass); */
			$(formId).parents(formHolder).addClass(sentClass);

			/* setTimeout(() => {
				$(formHolder).removeClass(sentClass);
			}, delay); */
		}, false);

		$('.js-cf7-holder__popup-close').on('click', function() {
			$(formHolder).removeClass(sentClass);
		});
	},

	contactScroll: () => {
		document.addEventListener('wpcf7invalid', function() {
			setTimeout(function() {
				$('html').stop().animate({scrollTop: $('.wpcf7-not-valid-tip').eq(0).offset().top -200});
			}, 100);
		}, false);
	},

	appending: () => {
		$('<span class="checkmark"></span>').insertAfter($('.acceptance').find('input'));
	},

	submitEffect: () => {
		const submitWrapp = $('.cf7-holder__inner').find('.contact__wrapper-input-submit');
		const submitBtn = submitWrapp.find('.wpcf7-submit');

		submitBtn.on('mouseenter', function() {
			$(this).parent().addClass('submit-active');
		});

		submitBtn.on('mouseleave', function() {
			$(this).parent().removeClass('submit-active');
		});
	},

	resumeDate: () => {
		$('.js-txt-resume').val('No file chosen');

		$('.wpcf7-file').on('change', function() {
			const last = $(this).val().split('\\').pop();
			$('.js-txt-resume').val(last);
		});
	},
};

export default FormHelpers;
